import React from "react";
import PropTypes from "prop-types";
import CameraQuestionOption from "./CameraQuestionOption";
import "./CameraQuestionPreface.css";
import HelperContent from "../helperContent/HelperContent";
import QuestionLabel from "../question/QuestionLabel";
import { has } from 'lodash';
import Footer from "../Footer";


const CameraQuestionPreface = ({ question = {}, store = {}, selectionMade = f => f, processDeviceInput = f => f }) => {
    let className = "camera-preface" + (has(question, "class") ? " " + question.class : "");

    return (
        <div className={className}>
            <QuestionLabel question={question} store={store}/>
            <HelperContent question={question} />

            <div className="camera-options">
                <ul className="w3-ul w3-padding-small">
                    {question.options.map(option => (
                        <li className="camera-option w3-xlarge w3-center" key={option.itemID}>
                            <CameraQuestionOption
                                question={question}
                                option={option}
                                cameraType={question.questionType}
                                captureAttr={question.cameraSpecifier}
                                onClick={() => selectionMade(option)}
                                processInputFunction={(f, executeImageAnalysis, advanceToNextQuestion) => {
                                    return processDeviceInput(f, option, executeImageAnalysis, advanceToNextQuestion);
                                }}
                            />
                        </li>
                    ))}
                </ul>
            </div>

            <Footer question={question}/>
        </div>
    );
};

CameraQuestionPreface.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object,
    selectionMade: PropTypes.func,
    processDeviceInput: PropTypes.func
};

export default CameraQuestionPreface;
